
/* General utility functions
*  Can be used anywhere
*/

//Reference: https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
export const uniqueID = () => (
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    let r = Math.random() * 16 | 0, v = c == "x" ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  })
);

//Removes the element from the array if it finds it
export const removeFromArr = (arr, val) => {
  let index = arr.indexOf(val);
  if (index !== -1) {
    return [
      ...arr.slice(0, index),
      ...arr.slice(index + 1),
    ];
  }
  return arr;
};

export const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

/* ------------------------ DATES & TIMES ------------------------ */
// Booking dates travel as "2026-10-03" and times as "16:00" (South African time) - these helpers never
// convert to the visitor's time zone, so the dates are the same wherever the visitor is

export const parseISODate = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const toISODate = (date) => (
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
);

export const addDays = (iso, days) => {
  const date = parseISODate(iso);
  date.setDate(date.getDate() + days);
  return toISODate(date);
};

//Saturday, 03 Oct 2026 (as in the Wix booking summary)
export const formatDateLong = (iso) => {
  const date = parseISODate(iso);
  return `${weekDays[date.getDay()]}, ${String(date.getDate()).padStart(2, "0")} ${months[date.getMonth()].slice(0, 3)} ${date.getFullYear()}`;
};

//03/10/2026
export const formatDateShort = (iso) => {
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};

//"16:00" -> "4:00 PM" (the Wix widget used 12 hour times)
export const formatTime12 = (time) => {
  const [h, m] = time.split(":").map(Number);
  const suffix = h >= 12 ? "PM" : "AM";
  const hour = h % 12 === 0 ? 12 : h % 12;
  return `${hour}:${String(m).padStart(2, "0")} ${suffix}`;
};

export const guestsLabel = (count) => (
  count === 1 ? "1 guest" : `${count} guests`
);

//Server date-times ("2026-09-29T13:42:11") -> 29 Sep 2026 13:42
export const formatDateTime = (value) => {
  if (!value) {
    return "";
  }
  const [datePart, timePart] = value.split("T");
  const [y, m, d] = datePart.split("-");
  return `${Number(d)} ${months[Number(m) - 1].slice(0, 3)} ${y} ${timePart.slice(0, 5)}`;
};

/* ------------------------ MISC ------------------------ */

//Will not trigger the callback until it hasn't been called at least 'wait' milliseconds
export const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
      timeoutId = null;
    }, wait);
  };
};

export const prefersReducedMotion = () => (
  window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches
);
